import React, { Component } from "react";
import PropTypes from "prop-types";
import { getFilteredFacetValues } from "./getFilteredFacetValues";
import SearchBox from "./SearchBox";
import isFilterableFacet from "./isFilterableFacet";

function withTextFilter(WrappedComponent) {
  class WithTextFilter extends Component {
    constructor(props) {
      super(props);

      this.state = { searchTerm: "" };
    }

    isFiltered = () => !!this.state.searchTerm.length;

    render() {
      const { facet, ...rest } = this.props;

      if (facet === undefined) return null;

      const searchBox = isFilterableFacet({ facet }) ? (
        <SearchBox
          searchTerm={this.state.searchTerm}
          onChange={({ target: { value } }) =>
            this.setState({ searchTerm: value })
          }
          onClear={() => this.setState({ searchTerm: "" })}
        ></SearchBox>
      ) : null;

      return (
        <WrappedComponent
          facet={facet}
          searchBox={searchBox}
          isFiltered={this.isFiltered()}
          clearSearchBox={() => this.setState({ searchTerm: "" })}
          filteredFacetValues={getFilteredFacetValues({
            facetValues: facet.facetValues,
            searchTerm: this.state.searchTerm
          })}
          {...rest}
        />
      );
    }
  }

  WithTextFilter.propTypes = {
    facet: PropTypes.shape({
      facetValues: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired
        })
      ).isRequired
    })
  };

  return WithTextFilter;
}

export default withTextFilter;
